import { render, staticRenderFns } from "./SPs.vue?vue&type=template&id=19b9a309&"
import script from "./SPs.vue?vue&type=script&lang=js&"
export * from "./SPs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports